"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OraclePriceRequiredError = exports.UnsupportedCurrencyConversionError = exports.MixedCurrencyTypeError = void 0;
exports.MixedCurrencyTypeError = new Error('Arguments provided to arithmetic functions must be of the same currency type.');
exports.UnsupportedCurrencyConversionError = new Error('This currency does not support this type of conversion');
exports.OraclePriceRequiredError = new Error('This conversion requires an oracle price to compute.');
//# sourceMappingURL=Errors.js.map